/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Preset_Name_PlaceholderInputs */



/**
* | output |
* | --- |
* | "Enter a name for this preset" |
*
* @param {Audio_Description_Export_Preset_Name_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_preset_name_placeholder = /** @type {((inputs?: Audio_Description_Export_Preset_Name_PlaceholderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Preset_Name_PlaceholderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Saisissez un nom pour ce préréglage")
	if (locale === "de") return /** @type {LocalizedString} */ ("Geben Sie einen Namen für diese Voreinstellung ein.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Inserisci un nome per questo preset")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Введите название для этого пресета.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Introduzca un nombre para este ajuste preestablecido")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("请为此预设输入名称")
	if (locale === "ja") return /** @type {LocalizedString} */ ("このプリセットの名前を入力してください")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इस प्रीसेट के लिए एक नाम दर्ज करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Insira um nome para esta predefinição.")
	return /** @type {LocalizedString} */ ("Enter a name for this preset")
});